import { IonCol, IonContent, IonGrid, IonHeader, IonPage, IonRow } from "@ionic/react";
import { ContentSection } from "./components/ContentSection";
import { ParamsWatcher } from "./components/ParamsWatcher";
import { SegmentsSection } from "./components/SegmentsSection";
import { Toolbar } from "./components/Toolbar";

export const TemplateDetail = () => {
  console.log("Template detail Render");

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <Toolbar />
      </IonHeader>

      <IonContent fullscreen>
        <ParamsWatcher />
        <IonGrid>
          <IonRow>
            <IonCol>
              <SegmentsSection />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <ContentSection />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
